import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs/rx';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../shared.functions';
import { GenericResponse, GenericSearchResponse, MotivoInasistencia, SearchMotivoInasistenciaRequest, EmpleadoComunidadHistorialDto } from '../model';

@Injectable({
    providedIn: 'root'
})
export class MotivoInasistenciaService extends CrudService<any, number, any, any> {
    httpCsvOptions = {};
    constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
        super(_http, 'MotivoInasistencia', sharedFunctions);
        this.httpCsvOptions =
        {
            headers: new HttpHeaders(
                { 'Content-type': 'text/csv' }
            ), responseType: 'blob'
        };
    }

    // MOTIVO INASISTENCIA
    getMotivoInasistencia(Id: number): Observable<GenericResponse<any>> {
        return this._http.get<GenericResponse<any>>(this._serviceUrl + '/' + Id, this.httpOptions);
    }

    getMotivoInasistenciaSearchUrl() {
        return this._serviceUrl + '/search';
    }
    saveMotivoInasistencia(guardarMotivoInasistencia: MotivoInasistencia): Observable<any> {
        return this._http.post<any>(this._serviceUrl + '/save', guardarMotivoInasistencia, this.httpOptions);
    }
    searchMotivoInasistencia(value: SearchMotivoInasistenciaRequest): Observable<GenericSearchResponse<any>> {
        var queryString = this.sharedFunctions.convertToQueryString(value);
        return this._http.get<GenericSearchResponse<any>>(this._serviceUrl + '/search' + queryString, this.httpOptions);
    }

    exportSearchMotivoInasistencia(value: SearchMotivoInasistenciaRequest): Observable<any> {
        var queryString = this.sharedFunctions.convertToQueryString(value);
        return this._http.get<any>(this._serviceUrl + '/export-search' + queryString, this.httpCsvOptions);
    }

    getEmpleadoHistorialObras(empleadoId: number): Observable<GenericResponse<EmpleadoComunidadHistorialDto[]>> {
        return this._http.get<GenericResponse<EmpleadoComunidadHistorialDto[]>>(this._serviceUrl + '/historial/' + empleadoId, this.httpOptions);
    }

    getTipoMotivoInasistencia(): Observable<any> {
        return this._http.get<any>(this._serviceUrl + '/tipos-motivos-inasistencias', this.httpOptions);
    }
}